import { Api } from '../AApi'

export const API_SRS = new Api({
  url: 'srs',
  isConvertFormData: true,
  only: ['list'],
})
